import {Link} from 'react-router-dom';
import React from "react";
import {NsCard} from "../../components/card/NsCard";
import ModalMsg from "../../components/ModalMsg";
import NsField from "../../components/fields/NsField";
import Translate from "../../components/Translate";

export default function LoginView({
                                      show,
                                      setShow,
                                      msgModal,
                                      formik,
                                      translate,
                                  }) {

    return (
        <div className="box-login sfondo-login login-center">
            <div className="ns-accesso ns-card">
                <NsCard onlyShowChildren={true}>
                    <ModalMsg
                        show={show}
                        handleClose={() => setShow(false)}
                        testo={msgModal}/>
                    <div className="row">
                        <div className="col-md-12 text-center">
                            <img src="YEP-logo.svg" className="logo-login" alt="YEP Logo" height="100"/>
                        </div>
                    </div>

                    <form className="row g-3 needs-validation" method="post" noValidate=""
                          onSubmit={formik.handleSubmit}>

                        <div className="col-12">
                            <NsField
                                id="email"
                                label={"E-mail"}
                                name="email"
                                type="email"
                                onChange={formik.handleChange}
                                valoreNoFormik={formik.values.email}
                                className="form-control"
                                placeholder={translate("Inserisci E-mail")}
                                isRequired={true}
                            />
                            <div className="invalid-feedback">
                                <Translate>L'indirizzo E-Mail deve essere valorizzato.</Translate>
                            </div>
                        </div>
                        <div className="col-12">
                            <NsField
                                id="password"
                                name="password"
                                label="Password"
                                type="password"
                                onChange={formik.handleChange}
                                valoreNoFormik={formik.values.password}
                                className="form-control"
                                placeholder={translate("Inserisci Password")}
                                isRequired={true}
                            />
                            <div className="invalid-feedback">
                                <Translate>La Password deve essere valorizzata.</Translate>
                            </div>
                        </div>

                        <div className="col-12 text-center">
                            <div className="d-grid gap-2">
                                <button type="submit" name="accedi" id="accedi"
                                        className="btn btn-dark">
                                    <i className="fas fa-sign-in-alt"/> <Translate>Accedi</Translate>
                                </button>
                            </div>
                        </div>
                        <div className="col-12 text-center pt-2">
                            <div className="d-grid gap-2 login-margin-bottom">
                                <Link to={"/recuperaPwd"}>
                                    <Translate>Recupera password</Translate>
                                </Link>
                            </div>
                        </div>
                    </form>
                    <div
                        className="card-footer"
                        style={{
                            fontSize: "0.8rem"
                        }}
                    >
                        <Translate>© YEP All rights reserved. Powered by Netsurf and Message</Translate>
                    </div>
                </NsCard>
            </div>
        </div>
    );
}
